<div class="header-trigger" (click)="themeService.isSidebarCollapsed = !themeService.isSidebarCollapsed">
  <span nz-icon [nzType]="themeService.isSidebarCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
</div>
<ul
  nz-menu
  nzMode="inline"
  class="app-sidebar"
  [nzSelectable]="false"
  [nzInlineCollapsed]="themeService.isSidebarCollapsed"
  nzNoAnimation
>
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/home']"
    routerLinkActive="ant-menu-item-selected"
    #rlaOverview="routerLinkActive"
  >
    <svg width="18" height="18" viewBox="0 0 20 20" role="img">
      <path d="M10 2.5L2.5 8.33333V17.5H7.5V12.5H12.5V17.5H17.5V8.33333L10 2.5Z" fill="currentColor" />
    </svg>

    <span class="menu-text" *ngIf="!themeService.isSidebarCollapsed">Home</span>
  </li>
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/market-overview']"
    routerLinkActive="ant-menu-item-selected"
    #rlaOverview="routerLinkActive"
  >
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8333 7.5V2.5H17.5V7.5H10.8333ZM2.5 10.8333V2.5H9.16667V10.8333H2.5ZM10.8333 17.5V9.16667H17.5V17.5H10.8333ZM2.5 17.5V12.5H9.16667V17.5H2.5Z"
        fill="currentColor"
      />
    </svg>

    <span class="menu-text" *ngIf="!themeService.isSidebarCollapsed">Market Overview</span>
  </li>
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/market-fan-exploration']"
    routerLinkActive="ant-menu-item-selected"
    #rlaFan="routerLinkActive"
  >
    <svg width="18" height="18" viewBox="0 0 20 20" role="img">
      <path
        d="M15.5667 10.2667C15.2185 9.91849 14.8051 9.64246 14.35 9.45439C13.895 9.26631 13.4073 9.1699 12.9149 9.17067C12.4226 9.17145 11.9352 9.26939 11.4807 9.4589C11.0263 9.6484 10.6137 9.92573 10.2667 10.275C9.91795 10.6226 9.64126 11.0356 9.45248 11.4904C9.26369 11.9451 9.16651 12.4326 9.16651 12.925C9.16651 13.4174 9.26369 13.9049 9.45248 14.3596C9.64126 14.8144 9.91795 15.2274 10.2667 15.575C10.8676 16.1734 11.6533 16.5509 12.496 16.6462C13.3387 16.7415 14.1889 16.549 14.9083 16.1L17.5 18.6583L18.6583 17.5L16.0833 14.9083C17.025 13.4333 16.8083 11.5 15.5667 10.2667ZM14.3917 14.3917C13.575 15.2083 12.2583 15.2 11.4417 14.3917C10.6333 13.575 10.6333 12.2583 11.45 11.4417C12.2583 10.6333 13.575 10.6333 14.3917 11.4417C15.2 12.2583 15.2 13.575 14.3917 14.3917ZM9.08333 16.75C8.53895 16.201 8.11842 15.5417 7.85 14.8167C5.225 14.375 3.33333 13.1333 3.33333 11.6667V14.1667C3.33333 16.0083 6.31667 17.5 10 17.5C9.66667 17.2833 9.35833 17.0333 9.08333 16.75ZM3.33333 7.5V10C3.33333 11.4 5.05833 12.6 7.5 13.0833V12.9167C7.5 12.1417 7.66667 11.375 7.98333 10.675C5.28333 10.25 3.33333 8.99167 3.33333 7.5ZM10 2.5C6.31667 2.5 3.33333 3.99167 3.33333 5.83333C3.33333 7.5 5.83333 8.9 9.04167 9.16667H9.08333C10.0833 8.11667 11.4667 7.5 12.9167 7.5C13.675 7.5 14.425 7.65833 15.1167 7.96667C15.5368 7.77458 15.9003 7.47728 16.1718 7.10353C16.4433 6.72979 16.6138 6.29227 16.6667 5.83333C16.6667 3.99167 13.6833 2.5 10 2.5Z"
        fill="currentColor"
      />
    </svg>
    <span class="menu-text" *ngIf="!themeService.isSidebarCollapsed">Market Fan Exploration</span>
  </li>
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/market-insights']"
    routerLinkActive="ant-menu-item-selected"
    #rlaInsights="routerLinkActive"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.5 17.5H3.16667C2.98986 17.5 2.82029 17.4298 2.69526 17.3047C2.57024 17.1797 2.5 17.0101 2.5 16.8333V2.5M5 11.6667L8.33333 8.33333L11.6667 11.6667L17.5 5.83333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <span class="menu-text" *ngIf="!themeService.isSidebarCollapsed">Market Insights</span>
  </li>
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/marketing-requests']"
    routerLinkActive="ant-menu-item-selected"
    #rlaRequest="routerLinkActive"
  >
    <svg width="18" height="18" viewBox="0 0 20 20" role="img">
      <path
        d="M5.5 5C5.36739 5 5.24021 5.05268 5.14645 5.14645C5.05268 5.24021 5 5.36739 5 5.5C5 5.63261 5.05268 5.75979 5.14645 5.85355C5.24021 5.94732 5.36739 6 5.5 6H14.5C14.6326 6 14.7598 5.94732 14.8536 5.85355C14.9473 5.75979 15 5.63261 15 5.5C15 5.36739 14.9473 5.24021 14.8536 5.14645C14.7598 5.05268 14.6326 5 14.5 5H5.5ZM6.5 11C6.89782 11 7.27936 10.842 7.56066 10.5607C7.84196 10.2794 8 9.89782 8 9.5C8 9.10218 7.84196 8.72064 7.56066 8.43934C7.27936 8.15804 6.89782 8 6.5 8C6.10218 8 5.72064 8.15804 5.43934 8.43934C5.15804 8.72064 5 9.10218 5 9.5C5 9.89782 5.15804 10.2794 5.43934 10.5607C5.72064 10.842 6.10218 11 6.5 11ZM6.5 10C6.36739 10 6.24021 9.94732 6.14645 9.85355C6.05268 9.75979 6 9.63261 6 9.5C6 9.36739 6.05268 9.24021 6.14645 9.14645C6.24021 9.05268 6.36739 9 6.5 9C6.63261 9 6.75979 9.05268 6.85355 9.14645C6.94732 9.24021 7 9.36739 7 9.5C7 9.63261 6.94732 9.75979 6.85355 9.85355C6.75979 9.94732 6.63261 10 6.5 10ZM8 13.5C8 13.8978 7.84196 14.2794 7.56066 14.5607C7.27936 14.842 6.89782 15 6.5 15C6.10218 15 5.72064 14.842 5.43934 14.5607C5.15804 14.2794 5 13.8978 5 13.5C5 13.1022 5.15804 12.7206 5.43934 12.4393C5.72064 12.158 6.10218 12 6.5 12C6.89782 12 7.27936 12.158 7.56066 12.4393C7.84196 12.7206 8 13.1022 8 13.5ZM7 13.5C7 13.3674 6.94732 13.2402 6.85355 13.1464C6.75979 13.0527 6.63261 13 6.5 13C6.36739 13 6.24021 13.0527 6.14645 13.1464C6.05268 13.2402 6 13.3674 6 13.5C6 13.6326 6.05268 13.7598 6.14645 13.8536C6.24021 13.9473 6.36739 14 6.5 14C6.63261 14 6.75979 13.9473 6.85355 13.8536C6.94732 13.7598 7 13.6326 7 13.5ZM9 9.5C9 9.36739 9.05268 9.24021 9.14645 9.14645C9.24021 9.05268 9.36739 9 9.5 9H14.5C14.6326 9 14.7598 9.05268 14.8536 9.14645C14.9473 9.24021 15 9.36739 15 9.5C15 9.63261 14.9473 9.75979 14.8536 9.85355C14.7598 9.94732 14.6326 10 14.5 10H9.5C9.36739 10 9.24021 9.94732 9.14645 9.85355C9.05268 9.75979 9 9.63261 9 9.5ZM9.5 13C9.36739 13 9.24021 13.0527 9.14645 13.1464C9.05268 13.2402 9 13.3674 9 13.5C9 13.6326 9.05268 13.7598 9.14645 13.8536C9.24021 13.9473 9.36739 14 9.5 14H14.5C14.6326 14 14.7598 13.9473 14.8536 13.8536C14.9473 13.7598 15 13.6326 15 13.5C15 13.3674 14.9473 13.2402 14.8536 13.1464C14.7598 13.0527 14.6326 13 14.5 13H9.5ZM6 3C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V14C3 14.7956 3.31607 15.5587 3.87868 16.1213C4.44129 16.6839 5.20435 17 6 17H14C14.7956 17 15.5587 16.6839 16.1213 16.1213C16.6839 15.5587 17 14.7956 17 14V6C17 5.20435 16.6839 4.44129 16.1213 3.87868C15.5587 3.31607 14.7956 3 14 3H6ZM4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H14C14.5304 4 15.0391 4.21071 15.4142 4.58579C15.7893 4.96086 16 5.46957 16 6V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H6C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0391 4 14.5304 4 14V6Z"
        fill="currentColor"
      />
    </svg>

    <span class="menu-text" *ngIf="!themeService.isSidebarCollapsed">Marketing Requests</span>
  </li>
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/resources']"
    routerLinkActive="ant-menu-item-selected"
    #rlaRequest="routerLinkActive"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M10.75 3.51675C15.6084 5.70008 16.6667 1.66675 16.6667 1.66675C16.6667 1.66675 15.7417 6.72508 11.4917 8.79175C10.625 9.21675 10.0834 9.44175 10.0834 9.44175L3.10836 6.04175L10.0834 3.18341C10.0834 3.18341 9.91669 3.13341 10.75 3.51675ZM9.26669 18.3334L2.77502 14.8167V7.55841L9.26669 10.8667V18.3334ZM10.7334 18.3334L17.2334 14.8167V7.55841L10.7334 10.8667V18.3334Z"
        fill="currentColor"
      />
    </svg>

    <span class="menu-text" *ngIf="!themeService.isSidebarCollapsed">Resources</span>
  </li>
</ul>
